<template>
    <b-modal
        id="copy-magazine-modal"
        v-model="modal"
        :title="$t('common.copy')"
        :ok-title="$t('common.copy')"
        @ok="copyMagazine"
        :cancel-title="$t('common.cancel')"
        cancel-variant="outline-primary"
        modal-class="apprentice-default-modal">
        <b-form>
            <div class="duplicate-magazine">
                <b-alert
                    class="duplicate-error"
                    v-if="error"
                    variant="danger "
                    show>
                    {{ $t('magazine.title_cannot_be_empty') }}
                </b-alert>

                <b-form-group
                    :label="$t('common.title') + ':'"
                    label-for="title">
                    <b-form-input
                        v-model="title"
                        :placeholder="$t('common.title')"
                        required>
                    </b-form-input>
                    <label
                        class="error mt-2 text-danger"
                        v-if="allerrors.copytitle"
                        >{{ allerrors.copytitle[0] }}</label
                    >
                </b-form-group>

                <b-form-group
                    :label="$t('magazine.active_for_print') + ':'"
                    label-for="activeforprint">
                    {{
                        $t(
                            'magazine.note_when_no_this_magazine_will_be_considered_a_test_version_and_not_sent_to_the_printer',
                        )
                    }}
                    <b-form-select
                        class="apprentice-primary-select"
                        id="activeforprint"
                        v-model="activeforprint"
                        required>
                        <option :value="1">{{ $t('common.yes') }}</option>
                        <option :value="0">{{ $t('common.no') }}</option>
                    </b-form-select>
                    <label
                        class="error mt-2 text-danger"
                        v-if="allerrors.activeforprint"
                        >{{ allerrors.witheditors[0] }}</label
                    >
                </b-form-group>

                <b-form-group
                    label="CJP actie:"
                    label-for="cjpPromotional">
                    <b-form-select
                        class="apprentice-primary-select"
                        v-model="cjpPromotional"
                        required>
                        <option value="1">{{ $t('common.yes') }}</option>
                        <option value="0">{{ $t('common.no') }}</option>
                    </b-form-select>
                    <label
                        class="error mt-2 text-danger"
                        v-if="allerrors.show_all_pages"
                        >{{ allerrors.show_all_pages[0] }}</label
                    >
                </b-form-group>

                <b-form-group
                    :label="$t('magazine.include_editor') + ':'"
                    label-for="witheditors">
                    <b-form-select
                        class="apprentice-primary-select"
                        id="witheditors"
                        v-model="withEditors"
                        required>
                        <option :value="1">{{ $t('common.yes') }}</option>
                        <option :value="0">{{ $t('common.no') }}</option>
                    </b-form-select>
                    <label
                        class="error mt-2 text-danger"
                        v-if="allerrors.withEditors"
                        >{{ allerrors.witheditors[0] }}</label
                    >
                </b-form-group>

                <b-form-group
                    :label="$t('magazine.include_contact') + ':'"
                    label-for="withcontact">
                    <b-form-select
                        class="apprentice-primary-select"
                        id="withcontact"
                        v-model="withContact"
                        required>
                        <option :value="1">{{ $t('common.yes') }}</option>
                        <option :value="0">{{ $t('common.no') }}</option>
                    </b-form-select>
                    <label
                        class="error mt-2 text-danger"
                        v-if="allerrors.withcontact"
                        >{{ allerrors.withcontact[0] }}</label
                    >
                </b-form-group>

                <b-form-group
                    :label="$t('magazine.include_index_pages')"
                    label-for="withcontent">
                    <b-form-select
                        class="apprentice-primary-select"
                        id="withcontent"
                        v-model="withContent"
                        required>
                        <option :value="1">{{ $t('common.yes') }}</option>
                        <option :value="0">{{ $t('common.no') }}</option>
                    </b-form-select>
                    <label
                        class="error mt-2 text-danger"
                        v-if="allerrors.withcontent"
                        >{{ allerrors.withcontent[0] }}</label
                    >
                </b-form-group>
            </div>
        </b-form>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-copy-magazine-modal-component',
    data() {
        return {
            magazine: null,
            id: null,
            error: false,
            title: '',
            activeforprint: 1,
            cjpPromotional: 0,
            withEditors: 1,
            withContact: 1,
            withContent: 0,
            allerrors: [],
            modal: false,
        };
    },
    methods: {
        show(magazine) {
            this.id = magazine.id;
            this.deadline_yearbook = magazine.deadline_year_book;
            this.cjpPromotional = magazine.cjpPromotional ?? 0;
            this.magazine = magazine;
            this.modal = true;
        },
        copyMagazine(e) {
            if (this.title === '') {
                e.preventDefault();
                this.error = true;
                return;
            }
            let data = {
                id: this.id,
                activeforprint: this.activeforprint,
                cjp_promotional: this.cjpPromotional,
                witheditors: this.withEditors,
                withcontact: this.withContact,
                withcontent: this.withContent,
                title: this.title,
            };

            this.alert.saving();

            this.axios
                .post(this.routes.magazineCopy(this.id), data)
                .then((response) => {
                    this.$emit('copy-magazine', response.data.magazine);
                    this.error = false;
                })
                .catch((error) => {
                    if (error.response) {
                        this.alert.ajaxError(error);
                    } else {
                        this.alert.ajaxError(error);
                    }
                });
        },
    },
};
</script>

<style scoped lang="scss"></style>
